/** Ported from haulsheet index.html ocrParseFuel + the fuel twin check in ocrReadScreenshot (Bennett / EFS fuel price list). */
import { ocrIsState, ocrTitle } from "./shared.js";
export function ocrParseFuel(lines) {
    const priceRe = /^\|?\$(\d{1,2}\.\d{3,4})\|?$/;
    let header = null;
    const out = [];
    for (const l of lines) {
        if (/\bCity\b/.test(l.text) && /\bState\b/.test(l.text) && /PPG/.test(l.text))
            header = l;
    }
    const cx = {};
    if (header) {
        header.words.forEach((w, i) => {
            if (/^Stop$/i.test(w.t) && header.words[i - 1])
                cx.stop = header.words[i - 1].x;
            else if (/^Road/i.test(w.t))
                cx.road = w.x;
            else if (/^City$/i.test(w.t))
                cx.city = w.x;
            else if (/^State$/i.test(w.t))
                cx.state = w.x;
        });
    }
    const cols = cx.stop != null && cx.road != null && cx.city != null && cx.state != null;
    for (const l of lines) {
        const prices = l.words.filter((w) => priceRe.test(w.t));
        if (prices.length < 2)
            continue;
        const before = l.words.filter((w) => w.x < prices[0].x && !/^\|+$/.test(w.t));
        const st = before[before.length - 1];
        const state = st ? st.t.replace(/[^A-Za-z]/g, "").toUpperCase() : "";
        if (!ocrIsState(state))
            continue;
        let body = before.slice(0, -1);
        let start = -1;
        body.forEach((w, i) => {
            if (/^\d{4}-$|^\d{4}-\d\d-?$/.test(w.t.replace(/\|/g, "")))
                start = i;
        });
        body = body.slice(start + 1);
        const txt = (ws) => ws
            .map((w) => w.t.replace(/^\|-/, "I-").replace(/\|/g, ""))
            .join(" ")
            .replace(/\s+/g, " ")
            .replace(/&amp;?|[&@;]+\s*$/g, "")
            .trim();
        const tol = l.words[0].h * 0.6;
        let stop;
        let city;
        let road;
        if (cols) {
            stop = txt(body.filter((w) => w.x < cx.road - tol));
            road = txt(body.filter((w) => w.x >= cx.road - tol && w.x < cx.city - tol));
            city = txt(body.filter((w) => w.x >= cx.city - tol));
        }
        else {
            stop = txt(body);
            road = "";
            city = "";
        }
        const retail = prices[0].t.match(priceRe)[1];
        const price = prices[1].t.match(priceRe)[1];
        if (!(+price > 1 && +price < 15))
            continue;
        out.push({ stop, road, city: ocrTitle(city), state, retail, price, _cy: l.cy });
    }
    return out;
}
/**
 * Fuel from both reads, as in ocrReadScreenshot: keep the read with more rows,
 * flag a row whose twin (same row within 25px) in the other read has a different price.
 * Sparse is passed first so ties go to sparse, matching `fa.length >= fb.length ? fa : fb`.
 */
export function ocrFuelFromPasses(sparseLines, blockLines) {
    const fa = ocrParseFuel(sparseLines);
    const fb = ocrParseFuel(blockLines);
    const fuel = fa.length >= fb.length ? fa : fb;
    const other = fuel === fa ? fb : fa;
    for (const f of fuel) {
        const twin = other.filter((o) => Math.abs((o._cy || 0) - (f._cy || 0)) < 25)[0];
        f.check = twin && twin.price !== f.price ? "read two ways: " + f.price + " and " + twin.price : "";
        delete f._cy;
    }
    return fuel;
}
//# sourceMappingURL=fuel.js.map